import {
  TimezoneAbbreviation,
  TimezoneDisplayName,
  TimezoneDisplayNameWithIdentifier,
  TimezoneName,
} from 'shared/enums/TimezoneNames';

const timezoneDisplayName: Record<TimezoneName, TimezoneDisplayName> = {
  [TimezoneName.US_EAST]: TimezoneDisplayName.US_EAST,
  [TimezoneName.US_CENTRAL]: TimezoneDisplayName.US_CENTRAL,
  [TimezoneName.US_MOUNTAIN]: TimezoneDisplayName.US_MOUNTAIN,
  [TimezoneName.US_PACIFIC]: TimezoneDisplayName.US_PACIFIC,
  [TimezoneName.US_ALASKA]: TimezoneDisplayName.US_ALASKA,
  [TimezoneName.US_HAWAII]: TimezoneDisplayName.US_HAWAII,
  [TimezoneName.US_HAWAII_ALEUTIAN]: TimezoneDisplayName.US_HAWAII_ALEUTIAN,
  [TimezoneName.US_ARIZONA]: TimezoneDisplayName.US_ARIZONA,
  [TimezoneName.US_PUERTO_RICO]: TimezoneDisplayName.US_PUERTO_RICO,
  [TimezoneName.US_ATLANTIC]: TimezoneDisplayName.US_ATLANTIC,
  [TimezoneName.US_ST_JOHNS]: TimezoneDisplayName.US_ST_JOHNS,
  [TimezoneName.CANADA_REGINA]: TimezoneDisplayName.CANADA_REGINA,
};

export const getTimezoneDisplayName = (timezoneName: string): TimezoneDisplayName => {
  return timezoneDisplayName[timezoneName as TimezoneName] || timezoneDisplayName[TimezoneName.US_CENTRAL];
};

const timezoneDisplayNameWithIdentifiers: Record<TimezoneName, TimezoneDisplayNameWithIdentifier> = {
  [TimezoneName.US_EAST]: TimezoneDisplayNameWithIdentifier.US_EAST,
  [TimezoneName.US_CENTRAL]: TimezoneDisplayNameWithIdentifier.US_CENTRAL,
  [TimezoneName.US_MOUNTAIN]: TimezoneDisplayNameWithIdentifier.US_MOUNTAIN,
  [TimezoneName.US_PACIFIC]: TimezoneDisplayNameWithIdentifier.US_PACIFIC,
  [TimezoneName.US_ALASKA]: TimezoneDisplayNameWithIdentifier.US_ALASKA,
  [TimezoneName.US_HAWAII]: TimezoneDisplayNameWithIdentifier.US_HAWAII,
  [TimezoneName.US_HAWAII_ALEUTIAN]: TimezoneDisplayNameWithIdentifier.US_HAWAII_ALEUTIAN,
  [TimezoneName.US_ARIZONA]: TimezoneDisplayNameWithIdentifier.US_ARIZONA,
  [TimezoneName.US_PUERTO_RICO]: TimezoneDisplayNameWithIdentifier.US_PUERTO_RICO,
  [TimezoneName.US_ATLANTIC]: TimezoneDisplayNameWithIdentifier.US_ATLANTIC,
  [TimezoneName.US_ST_JOHNS]: TimezoneDisplayNameWithIdentifier.US_ST_JOHNS,
  [TimezoneName.CANADA_REGINA]: TimezoneDisplayNameWithIdentifier.CANADA_REGINA,
};

export const getTimezoneDisplayNameWithIdentifier = (timezoneName: string): TimezoneDisplayNameWithIdentifier => {
  return (
    timezoneDisplayNameWithIdentifiers[timezoneName as TimezoneName] ||
    timezoneDisplayNameWithIdentifiers[TimezoneName.US_CENTRAL]
  );
};

const timezoneAbbreviations: Record<TimezoneName, TimezoneAbbreviation> = {
  [TimezoneName.US_EAST]: TimezoneAbbreviation.US_EAST,
  [TimezoneName.US_CENTRAL]: TimezoneAbbreviation.US_CENTRAL,
  [TimezoneName.US_MOUNTAIN]: TimezoneAbbreviation.US_MOUNTAIN,
  [TimezoneName.US_PACIFIC]: TimezoneAbbreviation.US_PACIFIC,
  [TimezoneName.US_ALASKA]: TimezoneAbbreviation.US_ALASKA,
  [TimezoneName.US_HAWAII]: TimezoneAbbreviation.US_HAWAII,
  [TimezoneName.US_HAWAII_ALEUTIAN]: TimezoneAbbreviation.US_HAWAII_ALEUTIAN,
  [TimezoneName.US_ARIZONA]: TimezoneAbbreviation.US_ARIZONA,
  [TimezoneName.US_PUERTO_RICO]: TimezoneAbbreviation.US_PUERTO_RICO,
  [TimezoneName.US_ATLANTIC]: TimezoneAbbreviation.US_ATLANTIC,
  [TimezoneName.US_ST_JOHNS]: TimezoneAbbreviation.US_ST_JOHNS,
  [TimezoneName.CANADA_REGINA]: TimezoneAbbreviation.CANADA_REGINA,
};

export const getTimezoneAbbreviation = (timezoneName: string): TimezoneAbbreviation => {
  return timezoneAbbreviations[timezoneName as TimezoneName] || timezoneAbbreviations[TimezoneName.US_CENTRAL];
};
